export const getSlugName = (str: string) => {
  if (!str) return "";
  return str
  .replace(/<[^>]*>/g, "")
    .replace(/^\d+[\.\-\)]\s*/, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}
